import { ChangeEvent, useContext, useState } from 'react';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-pro';
import { Tooltip } from '@mui/material';

import { ITextInputProps } from '@shared/inputs/TextInput';
import { GridTextInput } from '@styles/GridStyles';
import { GridRowContext } from './PhoenixGrid';

interface IGridColTextInputProps extends ITextInputProps {
  params: GridRenderEditCellParams;
  onChange?(event: ChangeEvent<HTMLInputElement>): void;
}

export const GridColTextInput = ({ params, onChange, ...rest }: IGridColTextInputProps) => {
  const api = useGridApiContext();
  const rowContext = useContext(GridRowContext);
  const [isAtLimit, setIsAtLimit] = useState(false);

  const { id, field, value } = params;
  const { maxLen } = rest;

  const handleChange = async(event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    if (maxLen && newValue.length > maxLen) return;

    setIsAtLimit(!!maxLen && newValue.length >= maxLen);

    if (rowContext.errors[field]) {
      rowContext.resetError(field);
    }

    api.current.setEditCellValue({ id, field, value: event.target.value });
    onChange?.(event);
  };

  const tooltipMessage = rowContext.errors[field] || (isAtLimit ? `Maximum ${maxLen} characters reached` : '');

  return (
    <Tooltip title={tooltipMessage}>
      <GridTextInput
        {...rest}
        unStyled
        inputProps={{ maxLen }}
        value={value || ''}
        error={Boolean(rowContext.errors[field])}
        onChange={handleChange}
      />
    </Tooltip>
  );
};
